__webpack_require__.p = "/assets/turbo/31471c3a/quellede/_next/";